import { render } from "./AllGlossaries.vue?vue&type=template&id=279d8353"
import script from "./AllGlossaries.vue?vue&type=script&lang=js"
export * from "./AllGlossaries.vue?vue&type=script&lang=js"

import "./AllGlossaries.vue?vue&type=style&index=0&id=279d8353&lang=css"

import exportComponent from "C:\\Users\\murodjon\\Desktop\\admin-uzcsd-uz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__